import { computed, ref } from 'vue';
import axios from 'axios';
import { t } from '../i18n';

// Feature names resolve lazily so they follow the active locale.
const competitorTier = () => ({
  features: ['on_demand_servers', 'refrag_coach', 'coach_feedback', 'scrim', 'utility_hub', 'academy', 'bootcamp', 'and_more']
    .map((key) => t(`shared.trial_campaign.features.${key}`)),
  label: t('shared.trial_campaign.competitor'),
  price: 15,
});

const playerTier = () => ({
  features: ['on_demand_servers', 'refrag_coach', 'quickfire', 'prefire', 'nadr', 'bootcamp', 'and_more']
    .map((key) => t(`shared.trial_campaign.features.${key}`)),
  label: t('shared.trial_campaign.player'),
  price: 7,
});

export function useTrialCampaign() {
  const campaign = ref(null);
  const loading = ref(true);
  const submitting = ref(false);

  const isPlayerTier = computed(
    () => campaign.value?.subscription_tier?.toLowerCase() === 'player',
  );

  const tierLabel = computed(() => (isPlayerTier.value ? t('shared.trial_campaign.player_tier') : t('shared.trial_campaign.competitor')));

  const tier = computed(() => (isPlayerTier.value ? playerTier() : competitorTier()));

  function getCampaignErrorMessage(err) {
    return (
      err.response?.data?.message
      || err.response?.data?.error
      || err.response?.data?.errors?.[0]
      || (err.response?.status === 404
        ? t('shared.trial_campaign.offer_unavailable')
        : t('shared.trial_campaign.load_error'))
    );
  }

  function getStartTrialErrorMessage(err) {
    return (
      err.response?.data?.message
      || err.response?.data?.error
      || err.response?.data?.errors?.[0]
      || t('shared.trial_campaign.start_error')
    );
  }

  async function fetchCampaign(campaignName) {
    const { data } = await axios.get(
      `/free_trial_campaigns/${encodeURIComponent(campaignName)}`,
    );
    const parsed = typeof data === 'string' ? JSON.parse(data) : data;
    campaign.value = parsed;
    return parsed;
  }

  async function startTrial(campaignName) {
    return axios.post(
      `/free_trial_campaigns/${encodeURIComponent(campaignName)}/start`,
      { source: campaignName },
    );
  }

  return {
    campaign,
    loading,
    submitting,
    isPlayerTier,
    tierLabel,
    tier,
    fetchCampaign,
    startTrial,
    getCampaignErrorMessage,
    getStartTrialErrorMessage,
  };
}
